import { MessagePrimitive } from '@assistant-ui/react';
import { faCircleUser } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type FC } from 'react';
import { Text } from './Text';
import './UserMessage.scss';

export const UserMessage: FC = () => (
  <MessagePrimitive.Root asChild>
    <section className={'chat-message chat-user-message'}>
      <figure className={'chat-avatar is-hidden-mobile'}>
        <p className={'image is-32x32'}>
          <FontAwesomeIcon icon={faCircleUser} size={'2x'} />
        </p>
      </figure>
      <main className={'chat-message-content'}>
        <MessagePrimitive.Content components={{ Text }} />
      </main>
    </section>
  </MessagePrimitive.Root>
);
UserMessage.displayName = 'UserMessage';
